/** @format */
/* eslint-disable no-underscore-dangle */

interface WindowRoot extends Window {
  __doNotUse?: Record<string, unknown>;
}

interface Root {
  __doNotUse?: Record<string, unknown>;
}

const root: Root | WindowRoot = typeof window === 'undefined' ? {} : window;

const safety = () => {
  root.__doNotUse = root.__doNotUse || {};
  return root.__doNotUse;
};

export const getSingleton = <T extends unknown>(key: string): T => {
  const __doNotUse = safety();
  return __doNotUse[key] as T;
};

export const registerSingleton = <T extends unknown>(
  key: string,
  value: T,
): T => {
  const __doNotUse = safety();
  __doNotUse[key] = value;
  return getSingleton(key);
};
